var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solar:ranking-linear"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.41602 26.5859C2.41602 24.8761 2.41602 24.0219 2.94768 23.4926C3.47814 22.9609 4.33243 22.9609 6.04102 22.9609C7.75081 22.9609 8.6051 22.9609 9.13435 23.4926C9.66602 24.0231 9.66602 24.8774 9.66602 26.5859V15.7109C9.66602 14.0011 9.66602 13.1469 10.1977 12.6176C10.7281 12.0859 11.5824 12.0859 13.291 12.0859H15.7077C17.4175 12.0859 18.2718 12.0859 18.801 12.6176C19.3327 13.1481 19.3327 14.0024 19.3327 15.7109V26.5859V22.9609C19.3327 21.2511 19.3327 20.3969 19.8644 19.8676C20.3948 19.3359 21.2491 19.3359 22.9577 19.3359C24.6675 19.3359 25.5218 19.3359 26.051 19.8676C26.5827 20.3981 26.5827 21.2524 26.5827 22.9609V26.5859",
    stroke: "#2063DA",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M13.4665 3.65409C13.9256 2.8288 14.1552 2.41797 14.4984 2.41797C14.8416 2.41797 15.0711 2.8288 15.5303 3.65409L15.6487 3.86676C15.7792 4.10118 15.8445 4.21718 15.946 4.29451C16.0487 4.37184 16.1756 4.40084 16.4293 4.45764L16.6589 4.5108C17.5506 4.71259 17.9965 4.81289 18.1028 5.15364C18.2092 5.49559 17.9047 5.85084 17.2969 6.56134L17.1398 6.74501C16.967 6.9468 16.88 7.04709 16.8413 7.17276C16.8027 7.29843 16.816 7.43255 16.8413 7.70201L16.8655 7.9473C16.9573 8.89584 17.0033 9.37072 16.7266 9.58097C16.4486 9.79243 16.0306 9.59909 15.1956 9.21484L14.9805 9.11576C14.7425 9.00701 14.6241 8.95143 14.4984 8.95143C14.3727 8.95143 14.2543 9.00701 14.0163 9.11576L13.8012 9.21484C12.9662 9.59909 12.5481 9.79243 12.2702 9.58097C11.9923 9.37072 12.0394 8.89584 12.1313 7.9473L12.1554 7.70201C12.1808 7.43255 12.1941 7.29843 12.1554 7.17276C12.1168 7.0483 12.0298 6.9468 11.857 6.74501L11.6999 6.56134C11.0921 5.85084 10.7876 5.49559 10.8939 5.15364C11.0003 4.81289 11.4461 4.71259 12.3379 4.5108L12.5675 4.45764C12.8212 4.40084 12.9481 4.37305 13.0508 4.29451C13.1523 4.21718 13.2176 4.10118 13.3481 3.86676L13.4665 3.65409Z",
    stroke: "#2063DA",
    strokeWidth: 2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/Rating.7578ec68d20dfe2042009f887277f0c9.svg";
export { ForwardRef as ReactComponent };